define('views/modules/calendar/animated-session/custom-exercises-manager/edit/custom-exercise-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // parents views
    'src/views/form-view',
    // views
    'views/parts/menu/menu-save-action',
    'views/modules/calendar/animated-session/custom-exercises-manager/form/exercise-form',
    'views/parts/alert/alert-list',
    // templates
    'text!templates/modules/calendar/animated-session/custom-exercises-manager/edit/custom-exercise-edit-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // parent views
    VForm,
    // views
    VMenuSaveAction,
    VExerciseForm,
    VAlertList,
    // templates
    TCustomExerciseEditContent
) {

    var VCustomExerciseEditContent = VForm.extend({

        template: TCustomExerciseEditContent,

        regions: {
            root: ".exercise-edit-content",
            menu: ".menu-actions",
            form: ".exercise-edit-form",
            alert: ".alert-list"
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.group = this.options.group;

            var view = this.view = {
                menu: new VMenuSaveAction({
                    context: this,
                    onClick: this.onActionClick,
                    onSave: this.onSave,
                    saveText: 'Save',
                    tooltip: {
                        container: this.regions.root,
                    }
                }),
                form: new VExerciseForm({
                    model: this.model,
                }),
                alert: new VAlertList()
            };

            this.listenTo(this.model, { 'change': this.onModelChange });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.setPristine();

            this.assign(view.menu, zone.$menu)
                .assign(view.form, zone.$form)
                .assign(view.alert, zone.$alert);

            this.view.alert.reset();

        },

        ////////////
        // events //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        onSubmit: function() {
            var model = this.model;
            if (model.isNew()) {
                model.set('group', this.group.id);
            }

            if (!model.has('animationUrl')) {
                model.unset('animation');
            }
        },

        onSave: function() {
            var animationUrl = this.model.get('animation') && this.model.get('animation').url;
            if (animationUrl != null && animationUrl.trim() === "") {
                delete this.model.attributes.animation;
            }
            this.submit();
        },

        onSuccess: function() {
            this.trigger('form:success', this.model.clone());
        },

        onError: function(error) {
            if (error && error.responseJSON) {
                this.view.alert.reset().addError("api-messages:" + error.responseJSON.code);
            }
        },

        onInvalid: function() {
            this.view.alert.reset();

            _.each(this.model.validationError, function(errors) {
                this.view.alert.addError(i18n.t(errors[0]));
            }, this);
        }
    });

    return VCustomExerciseEditContent;

});

